import React from "react";

const NotFound = () => {
  return (
    <main className="notfound">
      <div className="container">
        <h1>Not Found</h1>
      </div>
    </main>
  );
};

export default NotFound;
